import { render, staticRenderFns } from "./pictureManagement.vue?vue&type=template&id=4c9a585b&scoped=true"
import script from "./pictureManagement.vue?vue&type=script&lang=js"
export * from "./pictureManagement.vue?vue&type=script&lang=js"
import style0 from "./pictureManagement.vue?vue&type=style&index=0&id=4c9a585b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9a585b",
  null
  
)

export default component.exports